import React from 'react';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  const scrollToOffer = () => {
    const element = document.getElementById('oferta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const scrollToInfo = () => {
    const element = document.getElementById('que-incluye');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="hero" className="relative flex items-center justify-center overflow-x-hidden pt-14 sm:pt-20 pb-4 min-h-[85vh]" data-id="element-96">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-97">
        <img src="https://cdn.magicpatterns.com/uploads/3tzj2sUU4JF13C1DACyEPf/WhatsApp_Image_2026-03-04_at_01.31.17.jpg" alt="Metodología de la Investigación" className="w-full h-full object-cover object-center" data-id="element-98" />
        {/* Gradient Overlay: 70% bottom → 35% top */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628]/95 via-[#0a1628]/70 to-[#0a1628]/55" data-id="element-99"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-3 sm:px-6 text-center flex flex-col items-center" data-id="element-100">
        {/* Badge */}
        <div className="inline-block bg-[#fbbf24]/30 backdrop-blur-sm text-white px-3 py-1.5 rounded-full sm:text-sm mb-2 border border-[#fbbf24]/50 text-[11px] sm:text-[12px] font-[600] leading-snug text-center" data-id="element-101">
          ⭐ El recurso #1 para docentes de Metodología en Ciencias Sociales ⭐
        </div>

        {/* H1 Title */}
        <h1 className="text-xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-white leading-snug mb-1 px-1" style={{
        textShadow: '0 2px 8px rgba(0,0,0,0.7), 0 4px 20px rgba(0,0,0,0.5)'
      }} data-id="element-102">
          Resolvé todo tu año de Metodología de la Investigación en un solo
          lugar y dejá de planificar desde cero
        </h1>

        {/* Recursos Completos Badge */}
        <p className="text-[#fbbf24] text-lg sm:text-2xl font-bold mb-2 drop-shadow-lg" data-id="element-103">
          Recursos completos.
        </p>

        {/* Product Mockup */}
        <div className="w-full max-w-sm sm:max-w-md md:max-w-lg mb-2 cursor-pointer transform hover:scale-105 transition-transform duration-300" onClick={scrollToOffer} data-id="element-104">
          <img src="https://cdn.magicpatterns.com/uploads/w8tEy8V8Tv7NVsMB7nMLNA/mockups_nuevo.png" alt="Kit Completo Metodología de la Investigación" className="w-full h-auto drop-shadow-2xl animate-float" data-id="element-105" />
        </div>

        {/* Subtitle */}
        <p className="text-sm sm:text-lg text-gray-200 max-w-2xl mx-auto mb-3 font-medium leading-relaxed drop-shadow-md px-1" data-id="element-106">
          📚 Diseñado por docentes para docentes de Orientación en Ciencias
          Sociales, para que ahorres meses de preparación y tengas tus clases
          listas para aplicar desde el primer día.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto" data-id="element-107">
          <button onClick={scrollToOffer} className="flex items-center justify-center bg-[#dc2626] hover:bg-red-700 text-white text-base sm:text-lg font-bold py-3 px-8 rounded-lg shadow-[0_4px_14px_0_rgba(220,38,38,0.5)] transition-all transform hover:-translate-y-1 w-full sm:w-auto border-b-4 border-red-900 active:border-b-0 active:translate-y-0" data-id="element-108">
            Adquirir Ahora <ArrowRight className="ml-2 h-5 w-5" data-id="element-109" />
          </button>

          <button onClick={scrollToInfo} className="flex items-center justify-center bg-transparent hover:bg-white/10 text-white border-2 border-white/40 text-base sm:text-lg font-semibold py-3 px-8 rounded-lg transition-all w-full sm:w-auto backdrop-blur-sm" data-id="element-110">
            Más Información
          </button>
        </div>
      </div>
    </section>;
}